export default "__VITE_ASSET__5cd58de1__"